import React from "react";

const ShopAddress = ({ appointment }) => {
  // const appointment = useSelector(selectAppointments);
  const shopConfig = appointment?.shopData;


  const formatPhoneNumber = (phoneNumber) => {
  // Remove all non-digits
  const cleaned = phoneNumber.replace(/\D/g, '');
  
  // Check if it's a US number with country code
  if (cleaned.length === 11 && cleaned.charAt(0) === '1') {
    // Format as +1(XXX)-XXX-XXXX
    return `+1(${cleaned.substring(1, 4)})-${cleaned.substring(4, 7)}-${cleaned.substring(7, 11)}`;
  } 
  // Standard 10-digit US number
  else if (cleaned.length === 10) {
    // Format as (XXX)-XXX-XXXX
    return `(${cleaned.substring(0, 3)})-${cleaned.substring(3, 6)}-${cleaned.substring(6, 10)}`;
  }
  
  // If it doesn't match expected formats, return the original
  return phoneNumber;
};
  return (

    <div
      className="text-center py-4 md:pb-0 md:text-right md:pr-4"
      style={{ fontSize: "9pt" }}
    >
      {shopConfig?.shopName?.name}
      <br />
      {shopConfig?.shopContact?.address?.street}
      <br />
      {shopConfig?.shopContact?.address?.city},{" "}
      {shopConfig?.shopContact?.address?.state}{" "}
      {shopConfig?.shopContact?.address?.zip}
      <br />
      {shopConfig?.shopContact?.phone?.number && (
        <span>
          <a 
            href={`tel:${shopConfig.shopContact.phone.number.replace(/\D/g, '')}`}
            className="text-inherit font-inherit"
            style={{ 
              color: 'inherit', 
              fontSize: 'inherit',
              fontWeight: 'inherit'
            }}
          >
            {formatPhoneNumber(shopConfig.shopContact.phone.number)}
          </a>
          
        </span>
      )}
    </div>
  );
};

export default ShopAddress;
